var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutForm",
    [
      _c("template", { slot: "header" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$router.back()
              },
            },
          },
          [_vm._v("Back")]
        ),
        _vm._v(" "),
        _c("h1", [_vm._v("Create Document Category")]),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form",
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("ValidationAlert", {
            attrs: { "error-list": _vm.errors.collect("server") },
          }),
          _vm._v(" "),
          _c(
            "fieldset",
            { staticClass: "form__group" },
            [
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.name,
                      expression: "formData.name",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "name",
                    type: "text",
                    name: "name",
                    placeholder: "Enter a category name...",
                  },
                  domProps: { value: _vm.formData.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "name" } },
                  [_vm._v("Category name")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.description,
                      expression: "formData.description",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "description",
                    type: "description",
                    name: "name",
                    placeholder: "Enter a short category description...",
                  },
                  domProps: { value: _vm.formData.description },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "description", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "name" } },
                  [_vm._v("Category Description")]
                ),
              ]),
              _vm._v(" "),
              _c("FormControlInsightCategory", {
                ref: "cats",
                attrs: {
                  label: "Select a parent category (optional)",
                  name: "parent",
                },
                model: {
                  value: _vm.formData.parent,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "parent", $$v)
                  },
                  expression: "formData.parent",
                },
              }),
              _vm._v(" "),
              _c("FormControlEvent", {
                ref: "events",
                attrs: {
                  label: "Select a related event (optional)",
                  "allow-empty": true,
                  name: "event",
                },
                model: {
                  value: _vm.formData.event,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "event", $$v)
                  },
                  expression: "formData.event",
                },
              }),
              _vm._v(" "),
              _c("FileUpload", {
                ref: "imageUpload",
                attrs: {
                  id: "image",
                  label: "Image",
                  name: "image",
                  multiple: false,
                },
                model: {
                  value: _vm.formData.image,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "image", $$v)
                  },
                  expression: "formData.image",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group form__group--submit" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "wait",
                        rawName: "v-wait:disabled",
                        value: "submit",
                        expression: '"submit"',
                        arg: "disabled",
                      },
                    ],
                    staticClass: "btn btn--primary",
                  },
                  [
                    _vm.$wait.is("submit")
                      ? _c("Spinner", { attrs: { height: 13, width: 13 } })
                      : _c("span", [_vm._v("Save")]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }